import { createContext } from "react";

export const AuthContext = createContext(null);
export const ApiContext = createContext(null);
export const DataContext = createContext(null);
export const RouteContext = createContext(null);
